<script setup lang="ts">
import { AppToast, useToast } from '@vinprop/design-system'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterView, useRouter } from 'vue-router'

import UndoToast from '@/components/UndoToast.vue'
import { createdIssueKey } from '@/features/issues/created'

const { t } = useI18n()
const router = useRouter()
const toast = useToast()

/** Плашка о заведённой задаче — общая на все экраны, где её заводят (DEV-2074) */
const createdMessage = computed(() =>
  createdIssueKey.value ? t('issues.create.created', { key: createdIssueKey.value }) : '',
)

const openCreated = () => {
  if (createdIssueKey.value) void router.push(`/issue/${createdIssueKey.value}`)
}

const copyCreated = async () => {
  if (!createdIssueKey.value) return

  try {
    await navigator.clipboard.writeText(`${window.location.origin}/issue/${createdIssueKey.value}`)
    toast.success(t('issues.create.linkCopied'))
  } catch {
    toast.error(t('issues.create.copyFailed'))
  }
}
</script>

<template>
  <RouterView />

  <!-- Ключ созданной задачи виден и после того, как форма закрылась: без него
       задачу ищут в списке глазами, а «Открыть» ведёт прямо в карточку. -->
  <UndoToast
    :message="createdMessage"
    :action-label="t('issues.create.open')"
    :copy-label="t('issues.create.copy')"
    :duration="15000"
    @action="openCreated"
    @copy="copyCreated"
  />

  <!-- Один контейнер на всё приложение: сообщения приходят из composable, а не
       от конкретного экрана — иначе отказ переноса на доске остался бы виден
       только как прыгнувшая обратно карточка. -->
  <AppToast />
</template>
